export default __webpack_public_path__ + "static/node_runner@2x-6d25b152736268d7ff38eb80fcf482f7.png";